import React, { useState } from "react";
import axios from "axios";

function BuyCallingCard() {
  const [cardType, setCardType] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleCardTypeChange = (event) => {
    setCardType(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axios.post(
        "https://aichat-uat.azurewebsites.net/api/createCallingCard",
        { card_type: cardType, owner_id: ownerId }
      );
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Buy Calling Card</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="cardType">Card Type:</label>
          <select id="cardType" value={cardType} onChange={handleCardTypeChange}>
            <option value="">Select a card type</option>
            <option value="5_min">5 Minute Card</option>
            <option value="30_min">30 Minute Card</option>
            <option value="60_min">60 Minute Card</option>
            <option value="120_min">120 Minute Card</option>
            <option value="5_min_monthly">5 Minute Monthly Card</option>
            <option value="30_min_monthly">30 Minute Monthly Card</option>
            <option value="60_min_monthly">60 Minute Monthly Card</option>
            <option value="120_min_monthly">120 Minute Monthly Card</option>
          </select>
        </div>
        <div>
          <label htmlFor="ownerId">Owner ID:</label>
          <input
            type="text"
            id="ownerId"
            value={ownerId}
            onChange={(event) => setOwnerId(event.target.value)}
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create"}
        </button>
      </form>
      {error && <p>Error: {error}</p>}
      {success && <p>Calling card created successfully!</p>}
    </div>
  );
}

export default BuyCallingCard;